import type { RouteObject } from 'react-router';

import * as searchOrgsHorizonRouteExports from '#/modules/search/orgs/page/SearchOrgs.horizon-route';
import { searchOrgsRoutePaths } from '#/modules/search/orgs/routing/searchOrgs.route-paths';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

export const searchOrgsRouteObjects = searchOrgsRoutePaths.map((path) => ({
  path,
  ...horizonRouteToObject(searchOrgsHorizonRouteExports),
})) satisfies RouteObject[];
